import type { ThemeConfig } from 'antd';

export const COLOR = {
  accent: '#3EC247',
  black: '#262626',
  box: '#F6F6F6',
  danger: '#FF4218',
  success: '#4AAD84',
  white: '#FFFFFF',
  border: '#E8E8E8',
  textSecondary: '#8C8C8C',
} as const;

/** Main content area padding (SecureAppLayout inner shell). */
export const LAYOUT = {
  contentPadding: 16,
  secondaryHeaderPaddingX: 16,
  pageGutterX: 8,
} as const;

export const themeConfig: ThemeConfig = {
  token: {
    colorPrimary: COLOR.accent,
    colorError: COLOR.danger,
    colorSuccess: COLOR.success,
    colorTextBase: COLOR.black,
    colorBgLayout: COLOR.box,
    colorBgContainer: COLOR.white,
    colorBorder: COLOR.border,
    colorTextSecondary: COLOR.textSecondary,
    fontFamily: '"Nunito Sans", -apple-system, BlinkMacSystemFont, sans-serif',
    borderRadius: 6,
    fontSize: 14,
    lineHeight: 1.57,
    paddingContentHorizontal: LAYOUT.pageGutterX,
    paddingContentVertical: 8,
    motionDurationMid: '0.15s',
    motionDurationSlow: '0.2s',
  },
  components: {
    Layout: {
      siderBg: COLOR.white,
      headerBg: COLOR.white,
      bodyBg: COLOR.box,
    },
    Menu: {
      itemBg: 'transparent',
      itemSelectedBg: `${COLOR.accent}14`,
      itemSelectedColor: COLOR.accent,
      itemHoverBg: COLOR.box,
      itemHoverColor: COLOR.black,
      subMenuItemBg: COLOR.box,
      itemBorderRadius: 0,
      subMenuItemBorderRadius: 0,
      itemMarginInline: 0,
      itemMarginBlock: 0,
    },
    Table: {
      headerBg: COLOR.box,
      headerColor: COLOR.black,
      rowHoverBg: `${COLOR.accent}08`,
      borderColor: COLOR.border,
    },
    Button: {
      defaultShadow: 'none',
      primaryShadow: 'none',
    },
    Card: {
      boxShadow: 'none',
      boxShadowSecondary: 'none',
    },
    Input: {
      activeShadow: 'none',
    },
    Select: {
      optionActiveBg: `${COLOR.accent}08`,
      optionSelectedBg: `${COLOR.accent}14`,
    },
    Tabs: {
      cardBg: COLOR.box,
      inkBarColor: COLOR.black,
      itemSelectedColor: COLOR.black,
      itemHoverColor: COLOR.black,
      itemColor: COLOR.textSecondary,
      itemActiveColor: COLOR.black,
    },
  },
};
